import React from 'react';
import TrackItem from './TrackItem';
function TrackList({ tracks, currentTrack, onSelectTrack, trackColours, trackMutes, onToggleMute }) {
    return (React.createElement("div", { className: "min-w-[300px] w-full bg-gray-900 text-white p-4 border border-gray-700 rounded" }, tracks.map((_, index) => (React.createElement("div", { className: "min-w-[280px]", key: index, onClick: () => onSelectTrack(index) },
        React.createElement(TrackItem, { track: { id: index, name: `Track ${index}` }, isActive: currentTrack === index, colour: trackColours[index], isMuted: trackMutes[index], onToggleMute: () => onToggleMute(index) }))))));
}
export default TrackList;
